module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBoldItalic.c4c99209.woff2";